var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-na",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h512v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-108.238.239l.856 368.58L466.598-.001l-574.84.238z",
    fill: "#3662a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.69 511.53l-1.347-383.25-578.98 383.54 580.33-.283z",
    fill: "#38a100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-107.868 396.61l.486 115.39 125.25-.16 611.76-410.14-.69-100.32L505.178.239l-613.05 396.37z",
    fill: "#c70000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    d: "M154.085 183.389l-23.183-13.997-13.413 23.577-13.05-23.73-23.393 13.742.572-27.1-27.107.212 14.045-23.21-23.554-13.366 23.754-13.097-13.693-23.368 27.099.52-.16-27.104 23.183 14 13.413-23.58 13.05 23.73 23.393-13.739-.572 27.1 27.103-.214-14.042 23.211 23.552 13.368-23.754 13.096 13.696 23.366-27.099-.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.768 119.933c0 27.247-22.261 49.336-49.721 49.336s-49.722-22.089-49.722-49.336 22.262-49.336 49.722-49.336 49.72 22.088 49.72 49.336z",
    fill: "#3662a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.976 119.932c0 21.5-17.43 38.93-38.93 38.93s-38.929-17.43-38.929-38.93 17.43-38.929 38.93-38.929 38.929 17.43 38.929 38.93z",
    fill: "#ffe700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNa);
export default __webpack_public_path__ + "static/media/na.a6489bdf3b11cf2817b96e4c26cb77d3.svg";
export { ForwardRef as ReactComponent };